import {APIPromise, requestPromiseTypeWrapper} from "../services/HttpService";
import {DatasetInfo} from "./model/dataset/DatasetInfo";
import {BaseDatasetDTO} from "./model/dataset/BaseDatasetDTO";
import {DatasetCategoryDTO} from "./model/datset/DatasetCategoryDTO";
import {ApiDefinition} from "./ApiDefinition";


const promise = requestPromiseTypeWrapper;

class DatasetsApiDefinition extends ApiDefinition {

    constructor() {
        super("/datasets")
    }

    async getDatasetCategories(): APIPromise<DatasetCategoryDTO[]> {
        try {
            const {data} = await this.httpClient.get(`${this.apiScopeUrl}/categories`);
            const obj = data.map((it: Partial<DatasetCategoryDTO>) => new DatasetCategoryDTO(it))
            return {data: obj}
        } catch (error: any) {
            return {error: error.response?.data};
        }
    }

    async getBaseDataset(identifier: string | undefined | null): APIPromise<BaseDatasetDTO | null> {
        if (!identifier) {
            return {data: null};
        }

        try {
            const {data} = await this.httpClient.get(`${this.apiScopeUrl}/${identifier}`);
            const obj = new BaseDatasetDTO(data)
            return {data: obj}
        } catch (error: any) {
            return {error: error.response?.data};
        }
    }

  async queryDatasets(query?: string | null, limit?: number | null, identifiers?: string[] | null): APIPromise<DatasetInfo[]> {
    const params = {
      query: query || null,
      limit: limit,
      identifiers: identifiers?.join(",") || undefined,
    };

        try {
            const {data} = await this.httpClient.get(`${this.apiScopeUrl}/search`, {params: params});
            const obj = data.map((it: any) => new DatasetInfo(it))
            return {data: obj}
        } catch (error: any) {
            return {error: error.response?.data};
        }
    }

    async getDatasetInfo(identifier: string | null): APIPromise<DatasetInfo> {
        if(!identifier) return {data: undefined};

        return promise(this.httpClient.get(`${this.apiScopeUrl}/search`, {params: {identifiers: identifier}}), (data: any) => {
            return new DatasetInfo(data[0]);
        });
    }

    async getDatasetsInfo(identifiers: Array<string | null>): APIPromise<Array<DatasetInfo>> {
        const ids = identifiers.filter(e => e!=null)
        if(!ids) return {data: undefined};

        return promise(this.httpClient.get(`${this.apiScopeUrl}/search`, {params: {identifiers: ids.join(",")}}), (data: any) => {
            return data.map((item:any) => new DatasetInfo(item))
        });
    }

    async getPaginatedDatasetsList(query?: string | null, page?: number | null, size?: number | null): APIPromise<DatasetInfo[]> {
        return promise(this.httpClient.get(`${this.apiScopeUrl}/infos`,
            { params: { query: query, page: page, size: size } }),
            (data: any) => data.map((d: Partial<DatasetInfo>) => new DatasetInfo(d)));
    }

    async getDatasetsCount(): APIPromise<number> {
        return this.get("count");
    }

    async putUpdateDatasetInfo(datasetInfo: BaseDatasetDTO): APIPromise<BaseDatasetDTO> {
        return this.put(`${datasetInfo.identifier}`, datasetInfo)
    }

    async getDefaultDatasetCategory():APIPromise<DatasetCategoryDTO> {
        return this.get("categories/default")
    }

    async createNewCategorizedDataset(data: Partial<BaseDatasetDTO>): APIPromise<BaseDatasetDTO> {
        return this.post("create-categorized", data)
    }
}

export const DatasetsApi = new DatasetsApiDefinition();
